import { render } from "./app-menu.vue?vue&type=template&id=1e9ae2c8&scoped=true"
import script from "./app-menu.vue?vue&type=script&lang=js"
export * from "./app-menu.vue?vue&type=script&lang=js"

import "./app-menu.vue?vue&type=style&index=0&id=1e9ae2c8&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e9ae2c8"]])

export default __exports__